import styled from "styled-components";
import { Flex } from "antd";

// ─── Page Shell ───────────────────────────────────────────────────────────────
// Extends AntD Flex; direction (vertical) is set via prop in JSX.

export const ProficiencyContainerStyled = styled(Flex)`
  height: 100%;
  overflow: hidden;
  background: ${(p) => p.theme?.colors?.cardBg ?? p.theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  /* Table surface follows the card color (cardBg) */
  .ant-table { background: transparent; }
  .ant-table-tbody > tr > td { background: transparent; }
`;

// ─── Table Scroll Area ────────────────────────────────────────────────────────
// Extends AntD Flex; flex="1" is set via prop in JSX to fill remaining height.
// Visual-only: overflow-y, position, sticky pagination pin.

export const TableAreaStyled = styled(Flex)`
  overflow-y: auto;
  position: relative;

  .ant-table-pagination {
    position: sticky;
    bottom: 0;
    background: ${(p) => p.theme?.colors?.cardBg ?? p.theme?.colors?.white ?? "#ffffff"};
    padding: 12px 16px;
    margin: 0 !important;
    border-top: 1px solid ${(p) => p.theme?.colors?.borderLight ?? "#E5E7EB"};
    justify-content: space-between;
  }

  .ant-pagination-total-text {
    margin-right: auto;
  }

  .paic-pagination-total {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .paic-pagination-total .is-active-text {
    color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
    font-weight: 500;
  }

  .paic-pagination-total .is-empty-text {
    color: ${(p) => p.theme?.colors?.textSecondary ?? "#8c8c8c"};
  }
`;

// ─── Table Wrapper ────────────────────────────────────────────────────────────
// Extends AntD Flex; direction (vertical) is set via prop in JSX.

export const GroupTableWrapperStyled = styled(Flex)`
  height: 100%;
`;
